module.exports = __webpack_public_path__ + "media/newstyle/images/logo-apple-color-ce793c41d1ac7cf4da732a4558659859.png";